import {FC, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, styled} from "@mui/material";
import {DateRange} from "@mui/x-date-pickers-pro";
import TimeOffCalendar from "./DateRangeCalendar";
import {useSSTranslation} from "@/i18n/useSSTranslation";

interface CalendarDialogProps {
	onClose: () => void;
	onAcceptDateRange: (value: DateRange<Date>) => void;
}

const CalendarDialog: FC<CalendarDialogProps> = ({
	onClose,
	onAcceptDateRange
}) => {
	const {t} = useSSTranslation();
	const [dateRange, setDateRange] = useState<DateRange<Date>>();

	const handleShouldDisableDate = (date: Date) => false;
	const handleDateRangeChange = (value: DateRange<Date>) => {
		setDateRange(value);
	}
	const handleOK = () => {
		onAcceptDateRange(dateRange);
		onClose();
	}

	const disableOkButton = !dateRange || dateRange.length < 2 || !dateRange[1];

	return (
		<Dialog
			open={true}
		>
			<DialogContent
				sx={(theme) => ({
					backgroundColor: theme.palette.background.paperElevation4
				})}
			>
				<TimeOffCalendar
					testIdPrefix=""
					onDateChange={handleDateRangeChange}
					onShouldDisableDate={handleShouldDisableDate}
				/>
			</DialogContent>
      		<DialogActions
				sx={(theme) => ({
					paddingTop: 0,
					backgroundColor: theme.palette.background.paperElevation4
				})}
			>
        		<ButtonStyled
					variant="text"
					aria-label="Cancel action"
					onClick={onClose}
        		>
					{t("team_progress_calendar_cancel", "Cancel")}
        		</ButtonStyled>
          		<ButtonStyled
					variant="text"
					aria-label="Add action"
					onClick={handleOK}
					disabled={disableOkButton}
          		>
            		{t("team_progress_calendar_add", "Add")}
          		</ButtonStyled>
      		</DialogActions>
		</Dialog>
	)
}

const ButtonStyled = styled(Button)(({theme}) => ({
	border: "none",
	color: theme.palette.primary.main,
	"&:hover": {
		backgroundColor: "transparent"
	}
}))

export default CalendarDialog;